import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'app-modal-termos-epi-layout',
  templateUrl: './modal-termos-epi-layout.component.html',
  styleUrls: ['./modal-termos-epi-layout.component.scss'],
})
export class ModalTermosEpiLayoutComponent implements OnInit {
  @ViewChild('dialogBody') dialogBody: ElementRef | undefined;
  @Input() visible: boolean = false;
  @Output() termosAceitos = new EventEmitter<boolean>(false);
  checkTermos: boolean = false;
  pdfSrc: string =
    'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf';
  loader: boolean = false;

  constructor(
    private permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.permissionService.getPermission();
    this.changeDetectorRef.detectChanges();
    this.scrollToTop();
  }

  aceitarTermos() {
    this.termosAceitos.emit(true);
  }

  onHide() {
    this.checkTermos = false;
    this.termosAceitos.emit(false);
  }

  scrollToTop() {
    setTimeout(() => {
      if (this.dialogBody) {
        this.dialogBody.nativeElement.scrollTop = 0;
      }
    }, 300);
  }
}
